<template>
  <div class="fromList" >
    <div class="right" ref="left">
      <tree :treedata="treeData" @treesList="treesList" @treesUid="treesUid" :keystree="keystree"  :treeHidder="false"    @Afffor="Afffor" :dataobjs="dataobjs" />
    </div>
    <div class="leftNLit">
      <div class="storch">
        <div class="inputs">
          <!-- <el-input
            placeholder="请输入内容"
            v-model="search"
            class="input-with-select"
            style="width:300px"
          >
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input> -->
          <div class="btnes">
            <!-- <el-button type="success" @click="addContent" style="margin-left:10px">查询</el-button> -->
            <el-button
              type="primary"
              icon="el-icon-edit"
              @click="lookDlg()"
              style="margin-left:20px"
            >{{dataobjs.xinzengyonghu}}</el-button>
          </div>
        </div>
      </div>
      <div style="height:500px" v-loading="Delectloading" :element-loading-text="textContent">
        <el-table
          :data="tabbData"
          stripe
          :row-class-name="tableRowClassName"
          :header-cell-style="{background:'#eef1f6',color:'#606266'}"
          border
        >
          <el-table-column
            :label="dataobjs.yonghuming"
            align="center"
            fixed
            prop="username"
            width="200"
          ></el-table-column>
          <el-table-column
            :label="dataobjs.jingxiaoshangkehudemingcheng"
            :show-overflow-tooltip="true"
            align="center"
          >
            <template
              slot-scope="{row}"
            >{{row.roletype == 1?row.dealername:row.roletype == 2 ?row.customername:''}}</template>
          </el-table-column>
          <el-table-column
            :label="dataobjs.yonghuquanqianleixing"
            :show-overflow-tooltip="true"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.roletype == 0? '平台账号' :scope.row.roletype==1 ?'经销商类账号' : '客户类账号' }}</span>
            </template>
          </el-table-column>
          <el-table-column
            :label="dataobjs.yonghuleixing"
            :show-overflow-tooltip="true"
            align="center"
            width="200"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.roletype1 == 0 ? '主账号' :'子账号' }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="国籍" :show-overflow-tooltip="true" align="center" width="120" prop="nationality"></el-table-column> -->
          <el-table-column :label="dataobjs.caozuo" align="center" width="400">
            <template slot-scope="{row}">
              <el-button size="mini" icon="el-icon-edit" type="primary" round @click="deiName(row)" v-if="roletypeValue == 0">{{dataobjs.denglu}}</el-button>
              <el-button
                size="mini"
                @click="editFrom(row)"
                round
                icon="el-icon-edit"
                type="primary"
              >{{dataobjs.xiugai}}</el-button>
              <el-button
                size="mini"
                type="danger"
                @click="deleData(row)"
                icon="el-icon-delete"
                round
              >{{dataobjs.shanchu}}</el-button>
              <el-button
                size="mini"
                icon="el-icon-view"
                round
                type="info"
                @click="detileData(row)"
              >{{dataobjs.chongzhimima}}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <page-helper :page-data="pageData" :total="total" :get-table-list="userList"></page-helper>
      </div>
      <el-dialog
        :title="title"
        :visible.sync="dialogVisibleAdd"
        width="40%"
        :modal="false"
        :close-on-click-modal="false"
        :before-close="hideList"
      >
        <add
          :diohide="diohide"
          :rule-form="ruleForm"
          :user-list="userList"
          ref="fromList"
          :dataobjs="dataobjs"
          :title="title"
        />
      </el-dialog>
    </div>
  </div>
</template>
<script>
import add from "./components/add";
import {
  userList,
  treeinfo,
  dealerDelete,
  ChongZhiPross,
  lang_fend,
  userIndexMode
} from "@/network/index";
import {baerUrl} from '../../network/baserURL'
import { setTimeout } from "timers";
import PageHelper from "@/components/common/PageHelper";
import tree from "@/components/common/tree";
export default {
  components: {
    PageHelper,
    tree,
    add,
  },
  data() {
    return {
      ruleForm: {
        roletype: "", //用户权限类型
        roletype1: "", //用户权限类型1
        optname: "", //用户名
        optpassword: "", //密码
      },
      lang_file: sessionStorage.getItem("lang_file"),
      roletypeValue:sessionStorage.getItem("roletypeValue"),
      pageData: {
        pagenum: 1, //页码  pagenum  2
        pagesize: 30, //数据   pagesize几条数据
      },
      total: null,
      search: "",
      dialogVisibleAdd: false,
      tabbData: [],
      treeData: [],
      Delectloading: false, //加载图表
      textContent: "正在努力加载中...", //加载提示文字
      title: "",
      Uind: "",
      dataobjs: {},
      jxsuuid: "",
      kuu_uid: "",
      keystree:[]
    };
  },
  mounted() {
    // this.userList();
    this.userIndexMode()
    this.treeinfo();
    this.lang_fend();
  },
  methods: {
    // 获取默认展开列表
    async userIndexMode(){
      let pagenum = this.pageData.pagenum; //页码
      let pagesize = this.pageData.pagesize; //多少条数据
      const {code,data,msg} = await userIndexMode(pagenum,pagesize)
       this.total = Number(data.pagelist[0].allrow);
      if (data.list != "") {
        this.tabbData = data.list;
        this.Delectloading = false;
      }
     let lengthInfo = data.default.length - 1;
      this.area_uuid = data.default[lengthInfo].uuid;
      // console.log(this.area_uuid);

      this.keystree.push(data.default[lengthInfo].uuid);
    },
    // 显示全部用户列表
    Afffor(e) {

      //  setTimeout(() => {
      //   var element = this.$refs.left;
      //   element.scrollIntoView();
      //   element.scrollIntoView(true);
      //   for (let i = 0; i < 6; i++) {
      //     element.scrollIntoView({ block: "end" });
      //   }

      //   element.scrollIntoView({
      //     behavior: "smooth",
      //     block: "end",
      //     inline: "nearest",
      //   });
      // }, 500);

    },
    // 获取客户
    treesUid(e) {
      // console.log(e);
      this.jxsuuid = "";
      this.kuu_uid = e;
        this.pageData.pagenum = 1
      this.userList();
    },
    // 获取经销商用户
    treesList(e) {
      // console.log(e);
      this.kuu_uid = "";
      this.jxsuuid = e;
       this.pageData.pagenum = 1
      this.userList();
    },
    //翻译
    async lang_fend() {
      let page = "userinfo_page";
      let objs = {
        page,
        lang_file: this.lang_file,
      };
      const { data, code } = await lang_fend(objs);
      this.dataobjs = data;
    },
    // 树形结构
    async treeinfo() {
      let levelid = 2;
      const { code, data, msg } = await treeinfo(levelid);
      if (code) {
        this.treeData = data;
      }
    },
    // 重置密码
    detileData(e) {
      // this.Uind = e.uuid;
      this.$confirm("此操作将重置密码, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning",
      })
        .then(async () => {
          const { msg, code } = await ChongZhiPross(e.uuid);
          // console.log(data);
          if (code) return this.$message.success(msg);
          this.$message.error(msg);
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消重置",
          });
        });
    },
    hideList(dom) {
      this.ruleForm = {
        roletype: "", //用户权限类型
        roletype1: "", //用户权限类型1
        optname: "", //用户名
        optpassword: "", //密码
        uuid: "",
        dealer_uuid: "", //经销商
        customer_uuid: "",
      };
      this.dialogVisibleAdd = false;
      // this.ruleForm = {}
    },
    tableRowClassName({ row, rowIndex }) {
      let index = rowIndex + 1;
      if (index % 2 == 0) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
    //修改
    editFrom(e) {
      this.title = this.dataobjs.xiugaiyonghu;
      console.log(e);

      // let dealer_uuid = e.dealer_uuid != '' ? e.dealer_uuid : e.
      this.ruleForm = {
        roletype: e.roletype, //用户权限类型
        roletype1: e.roletype1, //用户权限类型1
        optname: e.username, //用户名
        optpassword: "", //密码
        uuid: e.uuid,
        dealer_uuid: e.dealer_uuid, //经销商
        customer_uuid: e.customer_uuid,
      };
      this.dialogVisibleAdd = true;
      if (e.roletype == 1) {
        this.$nextTick(() => {
          this.$refs.fromList.fly = true;
        });
      } else if (e.roletype == 2) {
        this.$nextTick(() => {
          this.$refs.fromList.fly1 = true;
        });
      }
    },
    //  删除
    deleData(e) {
      this.$confirm(`${this.dataobjs.tishixinxi}`, `${this.dataobjs.tishi}`, {
        confirmButtonText: `${this.dataobjs.queding}`,
        cancelButtonText: `${this.dataobjs.quxiao}`,
        closeOnClickModal: false,
        type: "warning",
      })
        .then(async () => {
          let tablename = "tb_system_user";
          const { code, data, msg } = await dealerDelete(e.uuid, tablename);
          if (code) {
            this.userList();
            this.Delectloading = false;
            this.$message({
              type: "success",
              message:`${this.dataobjs.shanchuchenggong}`,
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message:`${this.dataobjs.yiquxiaoshanchu}`,
          });
        });
    },
    //获取用户列表
    async userList() {
      this.Delectloading = true;
      let pagenum = this.pageData.pagenum; //页码
      let pagesize = this.pageData.pagesize; //多少条数据
      // let dealer_uuid = ''
      // let curruuid = '01A16E9D48600ADB2980259DE9DE9E86'
      const { code, data, msg } = await userList(
        pagenum,
        pagesize,
        this.jxsuuid,
        this.kuu_uid
      );

      this.total = Number(data.pagelist[0].allrow);
      // console.log(data);
      
      if (data.list != "") {
        this.tabbData = data.list;
        this.Delectloading = false;
      }else{
          this.tabbData =data.list
         this.Delectloading = false;
      }
       
      // if (code) {
      //   this.tabbData = data;
      //   this.Delectloading = false;
      // } else {
      //   this.Delectloading = false;
      //   this.$message.error(msg);
      // }
    },
    diohide() {
      this.dialogVisibleAdd = false;
      this.ruleForm = {
        roletype: "", //用户权限类型
        roletype1: "", //用户权限类型1
        optname: "", //用户名
        optpassword: "", //密码
        uuid: "",
        dealer_uuid: "", //经销商
        customer_uuid: "",
      };
      //  this.ruleForm = {}
      //  this.$refs.fromList.dialogVisible();
    },
    lookDlg() {
      this.title = this.dataobjs.xinzengyonghu;
      this.dialogVisibleAdd = true;
    },
    // 查询
    // addContent() {},
    deiName(e) {
      console.log(e);
      
      setTimeout(()=>{
        //  window.open( 'https://www.ousuiot.com/login?username='+e.username)  
        window.open(`${baerUrl}?username=${e.username}`)
      },1000)
    },
  },
};
</script>
<style >
.fromList {
  height: 100%;
  display: flex;
  justify-content: space-between;
  overflow: auto;
}
.right {
  width: 257px;
  height: 100%;
  overflow: auto;
}
.leftNLit {
  /* flex: 80%; */
  width: 99.9%;
  height: 100%;
  overflow: auto;
  padding: 0 10px;
}
.inputs {
  display: flex;
  width: 500px;
  padding: 0 0 10px 0;
}
.inputs input {
  /* padding: 20px; */
}
.btnes {
  display: flex;
}
</style>
